import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IconColors, IconSizes} from '@techsee/techsee-ui-common/lib/icons/large-rounded-icon';
import {GuidenceProgressItem} from '../components/guidance-progress/GuidanceProgress';
import {ProgressList} from '../components/progress-list/ProgressList';
import {InviteStepsLayout} from './_Shared';
import {AgentGuidance} from '../components/agent-guidance/AgentGuidance';
import {InviteStepProps} from './_InviteGenericStep';
import {SimpleTabs, ITab} from '@techsee/techsee-ui-common/lib/tabs/simple';
import {InviteDeviceType} from '../../_contracts/InviteContracts';

@observer
export class ScreenShareCaptureGuidanceStep extends TechseeBaseComponent<InviteStepProps> {
    componentDidMount() {
        this.props.ctrl.setPagePlacement('invite-terms-screen-mirroring');
    }

    get progressItems(): GuidenceProgressItem[] {
        const {translate} = this.props.ctrl;

        return [
            {
                iconColor: IconColors.Green,
                label: translate('REACT.INVITE.PERMISSIONS.SCREEN_SHARE.USER_PERMISSION'),
                isActive: true,
                icon: 'check',
                isIconAnimated: false,
                iconNoBorder: true
            },
            {
                iconColor: IconColors.Blue,
                label: translate('REACT.INVITE.PERMISSIONS.SCREEN_SHARE.TITLE'),
                isActive: true,
                icon: 'screen',
                isIconAnimated: false,
                iconNoBorder: true,
                iconSize: IconSizes.XLarge
            }
        ];
    }

    getAndroidTabContent(device: InviteDeviceType) {
        const {progressItems} = this;
        const {translate} = this.props.ctrl;

        return () => (
            <div className={'guidance-progress row'}>
                <div className={'col-left col-sm-4'}>
                    <ProgressList progressList={progressItems} />
                </div>
                <div className={'col-left col-sm-4 mid-col'}>
                    <AgentGuidance
                        stepType={'screen-share'}
                        stepNum={1}
                        deviceType={device}
                        stepText={translate(
                            'REACT.INVITE.PERMISSIONS.SCREEN_SHARE.USER_PERMISSIONS_GUIDE_SCREEN_MIRRORING_ONE'
                        )}
                        tooltipPosition={{
                            top: '43%',
                            left: '77%'
                        }}
                    />
                </div>
                <div className={'col-left col-sm-4'}>&nbsp;</div>
            </div>
        );
    }

    getIosTabContent(device: InviteDeviceType) {
        const {progressItems} = this;
        const {translate} = this.props.ctrl;

        return () => (
            <div className={'guidance-progress row'}>
                <div className={'col-left col-sm-4'}>
                    <ProgressList progressList={progressItems} />
                </div>
                <div className={'col-left col-sm-6 mid-col'}>
                    <AgentGuidance
                        stepType={'screen-share'}
                        stepNum={1}
                        deviceType={device}
                        stepText={translate(
                            'REACT.INVITE.PERMISSIONS.SCREEN_SHARE.USER_PERMISSIONS_GUIDE_SCREEN_MIRRORING_IOS_ONE'
                        )}
                        tooltipPosition={{
                            top: '49%',
                            left: '28%'
                        }}
                    />
                    <AgentGuidance
                        stepType={'screen-share'}
                        stepNum={2}
                        deviceType={device}
                        stepText={translate(
                            'REACT.INVITE.PERMISSIONS.SCREEN_SHARE.USER_PERMISSIONS_GUIDE_SCREEN_MIRRORING_IOS_TWO'
                        )}
                        tooltipPosition={{
                            top: '65%',
                            left: '43%'
                        }}
                    />
                </div>
            </div>
        );
    }

    renderInternal() {
        const {translate} = this.props.ctrl;
        const _clientDeviceType = this.props.ctrl.clientDeviceType;
        const tabsList: ITab[] = [
            {
                title: InviteDeviceType.android,
                content: this.getAndroidTabContent(InviteDeviceType.android)
            },
            {
                title: InviteDeviceType.ios,
                content: this.getIosTabContent(InviteDeviceType.ios)
            }
        ];

        if (_clientDeviceType === InviteDeviceType.common) {
            return <React.Fragment />;
        }

        return (
            <InviteStepsLayout
                className={'screen-share-step'}
                h1Text={translate('REACT.INVITE.PERMISSIONS.SCREEN_SHARE.USER_PERMISSIONS')}
                h2Text={translate('REACT.INVITE.PERMISSIONS.SCREEN_SHARE.USER_PERMISSIONS_GUIDE_SCREEN_MIRRORING')}>
                <SimpleTabs
                    key={this.props.ctrl.getSelectedDeviceTabIndex}
                    tabsList={tabsList}
                    uid={'screen-share-tabs'}
                    initialTabIndex={this.props.ctrl.getSelectedDeviceTabIndex}
                    onChange={this.props.ctrl.onDeviceTabChange}
                />
            </InviteStepsLayout>
        );
    }
}
